import helpActionTypes from './HelpActionTypes';
export class HelpActions {
    createTicket(category, issue, managementGroup, description, userAlias, workspaceId, ccAliases = [], driAlias = 'ctdri') {
        return {
            type: helpActionTypes.CREATE_TICKET,
            payload: {
                CcAliases: [userAlias].concat(ccAliases),
                CreatedTime: new Date(),
                Description: description,
                DRIAlias: driAlias,
                WorkspaceId: workspaceId,
                ManagementGroup: managementGroup,
                Priority: 3,
                TaxonomyName: category !== null && category !== void 0 ? category : 'Control Tower',
                Team: 'DmExperimentation',
                Title: issue,
                UserAlias: userAlias,
                WorkItemId: 0,
            },
        };
    }
    creatingTicket() {
        return {
            type: helpActionTypes.CREATING_TICKET,
        };
    }
    createdTicket(payload) {
        return {
            type: helpActionTypes.CREATED_TICKET,
            payload,
        };
    }
    uploadUserFiles(payload) {
        return {
            type: helpActionTypes.UPLOAD_USER_FILE,
            payload: payload,
        };
    }
    uploadingUserFiles() {
        return {
            type: helpActionTypes.UPLOADING_USER_FILE,
        };
    }
    uploadedUserFiles(payload) {
        return {
            type: helpActionTypes.UPLOADED_USER_FILE,
            payload: payload,
        };
    }
    loadManagementGroups(workspaceId) {
        return {
            type: helpActionTypes.LOAD_MGMT_GRPS,
            payload: workspaceId,
        };
    }
    loadingManagementGroups() {
        return {
            type: helpActionTypes.LOADING_MGMT_GRPS,
        };
    }
    loadedManagementGroups(payload) {
        return {
            type: helpActionTypes.LOADED_MGMT_GRPS,
            payload,
        };
    }
    loadFlightData(flightName, managementGroup) {
        return {
            type: helpActionTypes.LOAD_FLIGHT_DATA,
            payload: {
                flightName: flightName,
                managementGroup: managementGroup,
            },
        };
    }
    loadingFlightData() {
        return {
            type: helpActionTypes.LOADING_FLIGHT_DATA,
        };
    }
    loadedFlightData(payload) {
        return {
            type: helpActionTypes.LOADED_FLIGHT_DATA,
            payload,
        };
    }
    deleteFlight(flightName, managementGroup) {
        return {
            type: helpActionTypes.DELETE_FLIGHT,
            payload: {
                flightName: flightName,
                managementGroup: managementGroup,
            },
        };
    }
    deletingFlight() {
        return {
            type: helpActionTypes.DELETING_FLIGHT,
        };
    }
    deletedFlight(payload) {
        return {
            type: helpActionTypes.DELETED_FLIGHT,
            payload,
        };
    }
    loadFlightControl(managementGroup, workspaceId) {
        return {
            type: helpActionTypes.LOAD_MDS_FLIGHT_CONTROL,
            payload: {
                managementGroup: managementGroup,
                workspaceId: workspaceId,
            },
        };
    }
    loadingFlightControl() {
        return {
            type: helpActionTypes.LOADING_MDS_FLIGHT_CONTROL,
        };
    }
    loadedFlightControl(payload) {
        return {
            type: helpActionTypes.LOADED_MDS_FLIGHT_CONTROL,
            payload,
        };
    }
    changeManagementGroup(alias, managementGroup) {
        return {
            type: helpActionTypes.CHANGE_MG,
            payload: {
                alias: alias,
                managementGroup: managementGroup,
            },
        };
    }
    changingManagementGroup() {
        return {
            type: helpActionTypes.CHANGING_MG,
        };
    }
    changedManagementGroup(payload) {
        return {
            type: helpActionTypes.CHANGED_MG,
            payload,
        };
    }
    loadCategories(managementGroup, workspaceId) {
        return {
            type: helpActionTypes.LOAD_CATEGORIES,
            payload: {
                managementGroup: managementGroup,
                workspaceId: workspaceId,
            },
        };
    }
    loadingCategories() {
        return {
            type: helpActionTypes.LOADING_CATEGORIES,
        };
    }
    loadedCategories(payload) {
        return {
            type: helpActionTypes.LOADED_CATEGORIES,
            payload,
        };
    }
    clearUploadedUserFileCache() {
        return {
            type: helpActionTypes.CLEAR_UPLOADED_FILE_CACHE,
        };
    }
}
export default new HelpActions();

//# sourceMappingURL=HelpActions.js.map
